var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('home-content',{attrs:{"content":_vm.content,"page_title":_vm.page_title}}),_c('image-block-links',{attrs:{"imageObjects":this.showExerciseImageMap}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }